import { useEffect, useRef, useState } from "react";
import { LoadingSkeleton } from "../../components/ui";
import "./DoctorSelector.css";

export default function DoctorSelector({
  doctors,
  selectedDoctor,
  onSelect,
  loading,
}) {
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const filteredDoctors = doctors.filter((doctor) =>
    doctor.name.toLowerCase().includes(search.toLowerCase()),
  );

  const selectDoctor = (doctorId) => {
    onSelect(doctorId);
    setOpen(false);
    setSearch("");
  };

  return (
    <div className="payments-selector" ref={containerRef}>
      <label className="selector-label">Select Doctor</label>
      {loading ? (
        <LoadingSkeleton width="320px" height="40px" />
      ) : (
        <div className="doctor-combobox">
          <div
            className={`doctor-combobox-trigger ${open ? "open" : ""}`}
            onClick={() => setOpen(!open)}
          >
            <span
              className={`doctor-combobox-placeholder ${selectedDoctor ? "selected" : ""}`}
            >
              {selectedDoctor
                ? `${selectedDoctor.name} (${selectedDoctor.totalAppointments} appointments)`
                : "Select a doctor..."}
            </span>
            <svg
              className="doctor-combobox-arrow"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </div>
          {open && (
            <div className="doctor-combobox-dropdown">
              <div className="doctor-combobox-search-wrap">
                <input
                  className="doctor-combobox-search"
                  type="text"
                  placeholder="Type to search..."
                  value={search}
                  onChange={(event) => setSearch(event.target.value)}
                  autoFocus
                />
              </div>
              <div className="doctor-combobox-list">
                {filteredDoctors.length === 0 ? (
                  <div className="doctor-combobox-empty">No doctors found</div>
                ) : (
                  filteredDoctors.map((doctor) => (
                    <div
                      key={doctor.id}
                      className={`doctor-combobox-option ${
                        doctor.id === selectedDoctor?.id ? "active" : ""
                      }`}
                      onClick={() => selectDoctor(doctor.id)}
                    >
                      <span className="doctor-option-name">{doctor.name}</span>
                      <span className="doctor-option-count">
                        {doctor.totalAppointments} appointments
                      </span>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
